export enum Language {
  en = 'en',
  nb = 'nb',
  nn = 'nn',
  se = 'se',
}
